// @ts-strict-ignore
import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  NgZone,
  Output,
  ViewChild
} from '@angular/core';
import {
  LMListComponent,
  LMListLookupSelectionEvent,
  LMListSelectionEvent
} from './lm-list.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { AppConstants } from '@utils/app.constants';

@Component({
  standalone: false,
  template:  `
    <lm-list #lmlistlookup
        [listUrlInfo]="listUrlInfo"
        [listSpec]="listSpec"
        [selectRequestData]="selectRequestData"
        [ngStyle]="{'width': '100%'}"

        (listRowSelected)="onRowsSelected($event)"
        (toolbarButtonEvent)="onToolbarButtonEvent($event)"
        (listDisplayed)="onListDisplayed()"
    >
    </lm-list>
  `,
  providers: [ LMRouteComponentService ]
})
export class LMListLookupDialogComponent implements AfterViewChecked {

  @ViewChild(forwardRef(() => LMListComponent)) selectList: LMListComponent;

  @HostListener('keyup', ['$event']) onKeyUp(event) {
    if (event.which === 13 && event.srcElement.nodeName !== 'BUTTON') {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
      if (this.selectList.getSelectedRows().length > 0) {
        // if a record is selected, then enter should be like clicking the ok button
        this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentNode.querySelector('button[id="' + this.buttonIds.ok + '"]').click();
      }
    }
  }

  /**
   *
   * @type {EventEmitter<LMListLookupSelectionEvent>}
   */
  @Output() lookupSelection = new EventEmitter<LMListLookupSelectionEvent>();

  /**
   *
   * @type {EventEmitter<string>}
   */
  @Output() titleChanged = new EventEmitter<string>();
  @Output() navigatingToolbarEvent = new EventEmitter<LMToolbarButtonEvent>();

  @Input() listUrlInfo: LMListUrlInfo;

  /**
   * The list spec of the select list used to Select a value for our
   * select field.
   */
  @Input() listSpec: LMListSpec;

  /**
   * The SelectRequestData containing what's needed to run the select and
   * page appropriately over it's records.
   */
  @Input() selectRequestData: SelectRequestData;

  /**
   * The button ids for the ok and cancel button
   */
  @Input() buttonIds: {ok: string, cancel: string};

  private executeFocus = false;

  constructor(
    private elementRef: ElementRef,
    private zone: NgZone) {  }

  ngAfterViewChecked(): void {
    if (this.executeFocus) {
      this.executeFocus = false;
      this.handleFocus();
    }
  }

  /**
   * Re-emit the row selection event.
   * @param listSelectionEvent
   */
  onRowsSelected(listSelectionEvent: LMListSelectionEvent) {
    const lookupSelectionEvent = new LMListLookupSelectionEvent(this, listSelectionEvent.selectedRows);
    this.lookupSelection.emit(lookupSelectionEvent);
  }

  /**
   * Re-emit title changed event from lm-list.component to that the apply function has a chance
   * to subscribe to it and in turn update the dialogs title.
   */
  onTitleChanged(newTitle: string) {
    this.titleChanged.emit(newTitle);
  }

  onToolbarButtonEvent(event: LMToolbarButtonEvent) {
    const id = event.actionReference.id.toUpperCase();
    if (id.indexOf(AppConstants.ACTION_TYPE_CREATE) > -1 ||
        id.indexOf(AppConstants.ACTION_TYPE_UPDATE) > -1 ) {
      this.navigatingToolbarEvent.emit(event);
    }
  }

  onListDisplayed() {
    this.executeFocus = true;
  }

  handleFocus() {
    // This needs to be in a timeout to ensure that the list in the modal is displayed before attempting to focus
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        // does the child list have a search form displayed initially or always
        if (this.selectList.hasSearchForm && this.selectList.showSearchForm) {
          this.selectList.searchFormComponent.elementRef.nativeElement.querySelectorAll('input')[0].focus();
          return;
        }

        // focus first row, first cell
        this.selectList.listContentComponent?.listGrid?.sohoDataGridComponent.setActiveCell(0, 0);
      }, 2);
    });
  }
}
